<template>
  <SiteHeader />
  <SiteBlobBanner
    title="RGPD"
  />
  <Suspense>
    <SiteRGPD />
  </Suspense>
  <SiteFooter />
  <SitePostFooter />
</template>

<script setup>
  import SiteHeader from '@/sections/SiteHeader'
  import SiteBlobBanner from '@/sections/SiteBlobBanner'
  import SiteRGPD from '@/sections/rgpd'
  import SiteFooter from '@/sections/SiteFooter'
  import SitePostFooter from '@/sections/SitePostFooter'

  const { setSeoMeta } = useSeo()
  
  setSeoMeta({
    title: 'Politique de Confidentialité RGPD - CRA Freelance',
    description: 'Politique de confidentialité et protection des données personnelles de CRA Freelance. Conformité RGPD pour la gestion des CRA des freelances en régie.',
    type: 'website',
    keywords: ['RGPD', 'politique de confidentialité', 'protection des données', 'freelance en régie', 'CRA', 'facturation']
  })

  definePageMeta({
    name: 'rgpd'
  })
</script>